module.exports = __webpack_public_path__ + "static/media/logo_image_5.18c18695.png";